import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BarCodeCategory, FocusInputType, KeyValues5, LocalService, RelationShipRole, InteractionType, TriggeredEvent, NumericConfig } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-business-relationship',
  templateUrl: './business-relationship.component.html',
  styleUrls: ['./business-relationship.component.scss']
})
export class BusinessRelationshipComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["biz_relationship"]; isBrnEditMode = true; @Input() isCustomerAsBusiness = false;
  @Input() id = ''; @Input() businessId = ''; @Input() currentUserId = ''; @Input() isReadOnly = false; @Input() reduceWidth: number = 1;
  @Input() isWithContactNumber = false; @Input() relationShipType = InteractionType.None; @Input() relationShipRole = RelationShipRole.None;
  @Output() onUserUpdated = new EventEmitter(); lastUserId = ''; lastBrn = ''; clearLeft = 0; @Input() isMultiCustomerTypes = false;
  brn = null; brn_language = ''; brn_name = ''; @Input() isPopupOpened = false; @Input() isInvalidRelationFound = false;
  ctryCode = ''; @Output() onUserTypeSwitched = new EventEmitter();
  @Output() OnPopupOpenedChanged = new EventEmitter();
  htmlId: string = ''; elementIds: any;

  isOpenUserAuthentication = false;

  phoneNumber = '';
  numericConfig: NumericConfig = {} as NumericConfig;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private profileManagementService: ProfileManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      brn: 'brn_' + this.htmlId,
      brn_display: 'brn_display_' + this.htmlId,
      brn_clear: 'brn_clear_' + this.htmlId,
      userAuthSaveBtnId: 'save_user_auth_brn_' + this.htmlId,
    };
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    if (this.id == '')
      this.id = this.htmlId;
    let element = document.getElementById(this.elementIds.brn_display) as HTMLElement;
    if (element) {
      this.clearLeft = element.offsetLeft + element.clientWidth - 30;
    }
    this.ctryCode = this.localService.selected.countryCode;
    this.numericConfig.maxDigits = this.localService.getContactMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() );
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.elementIds.brn = this.elementIds.brn + this.localService.getRandomString(5);
    this.lastUserId = this.currentUserId;
    this.onLoad();
  }


  onLoad() {
    if (this.currentUserId && this.currentUserId != '') {
      this.profileManagementService.getBrnDetailsByUser(this.currentUserId, this.businessId, this.relationShipType, this.relationShipRole).subscribe(result => {
        this.onSetBrnDetails(result, false);
      });
    } else {
      this.onClear();
    }
  }

  ngOnChanges(): void {
    if (this.isInvalidRelationFound) {
      this.isInvalidRelationFound = false;
      this.onAddBrn(true);
    } else {
      this.onLoad();
    }
  }

  onFocusOut() {
    this.localService.onFocusNextInput(this.id, FocusInputType.Button);
  }

  onBrnFocus(isFocus = true) {
    if (!this.isReadOnly) {
      if (isFocus) {
        this.isBrnEditMode = true;
        this.localService.onFocusNextInput(this.elementIds.brn, FocusInputType.TextBox, true);
      }
      else
        this.onUpdateBrn();
    }
  }

  isForceSaveUserAuth = false;
  onAddBrn(isForceSave = false) {
    if (!this.isPopupOpened) {
      this.isPopupOpened = true;
      this.isForceSaveUserAuth = isForceSave;
      this.isOpenUserAuthentication = true;
      this.OnPopupOpenedChanged.emit(this.isPopupOpened);
    }
  }

  onCloseUserAuthentication(isFromAnotherPopup: boolean, result?: any) {
    this.isPopupOpened = false;
    if (isFromAnotherPopup && this.localService.dataWhileClosingPopupAndTriggerButton) {
      result = this.localService.dataWhileClosingPopupAndTriggerButton;
      switch (result.event) {
        case TriggeredEvent.Ok: {
          this.phoneNumber = result.data;
          this.localService.onFocusNextInput(this.id, FocusInputType.Button, true);
          this.localService.onFocusNextInput(this.elementIds.userAuthSaveBtnId, FocusInputType.Button, true, true);
        } break;
      }
    } else if (result) {
      switch (result.event) {
        case TriggeredEvent.Ok: {
          this.brn = result.data;
          this.onUpdateBrn();
        } break;
        case TriggeredEvent.Switched: {
          this.onUserTypeSwitched.emit();
        } break;
        case TriggeredEvent.Scanned: {
          this.onQrScanned(result.data);
        } break;
        default: {
          this.brn = null;
        } break;
      }
    }
    this.OnPopupOpenedChanged.emit(this.isPopupOpened);
  }

  onSetBrnDetails(relationShip: KeyValues5, isEmit: boolean = true) {
    if (relationShip && relationShip.key) {
      this.isBrnEditMode = false;
      this.brn = relationShip.key;
      this.lastBrn = this.brn;
      this.brn_name = relationShip.v1;
      this.brn_language = relationShip.v2;
      this.currentUserId = relationShip.v3;
      this.isBrnEditMode = !(relationShip.key != null);
      if (isEmit && this.lastUserId != this.currentUserId) {
        this.lastUserId = this.currentUserId;
        this.onUserUpdated.emit(this.currentUserId);
      }
    }
  }

  onUpdateBrn() {
    this.phoneNumber = '';
    if (this.relationShipType != InteractionType.None || this.isWithContactNumber) {
      if (this.brn) {
        if (this.lastBrn != this.brn) {
          this.lastBrn = this.brn;
          this.profileManagementService.getBrnDetails(this.brn, this.businessId, this.isWithContactNumber, this.relationShipType, this.relationShipRole).subscribe(result => {
            if (!result.key) {
              this.phoneNumber = result.v4 ? result.v4 : this.brn;
              if (this.brn != result.v1) {
                this.brn = '';
              }
              this.onAddBrn(this.phoneNumber != '');
            } else {
              this.onSetBrnDetails(result);
            }
          });
        } else {
          this.isBrnEditMode = false;
        }
      } else {
        this.onLoad();
      }
    }
  }

  onClear(isEmit = false) {
    this.isBrnEditMode = true;
    this.brn = null;
    this.brn_name = '';
    this.brn_language = '';
    this.currentUserId = '';
    this.lastBrn = '';
    this.lastUserId = '';
    if (isEmit)
      this.onUserUpdated.emit(this.currentUserId);
  }

  onScanned() {
    this.onQrScanned(this.brn);
  }

  onQrScanned(value: string) {
    if (value.length >= 24 && value.startsWith(this.localService.barCodePrefix)) {
      let qr = this.localService.getDecodedQrCode(value);
      if (qr.isValid && ((this.isCustomerAsBusiness && qr.barCodeCategory == BarCodeCategory.Business) || (!this.isCustomerAsBusiness && qr.barCodeCategory == BarCodeCategory.Me))) {
        this.profileManagementService.getBrnDetailsByQr(qr.value, this.businessId, this.isCustomerAsBusiness, this.relationShipType, this.relationShipRole).subscribe(result => {
          if (result.key && result.key != '') {
            this.onSetBrnDetails(result, true);
          }
        });
      } else {
        this.brn = '';
      }
    }
  }
}
